@if (toggle && featureStatus) {
  <div class="chart-block">
    @if (chart.disclaimer) {
      <span class="poi-disclaimer">{{ chart.disclaimer }}</span>
    }

    <app-slide-toggle
      class="menu-toggle"
      [formControl]="toggle"
      [disabled]="disabled"
      [ngClass]="disabled ? 'disabled' : ''"
      [attr.data-cy]="'toggle-' + chart.e2eName"
      >{{ chart.toggleTitle }}

      @if (chart.tooltip || disabled) {
        <app-feature-tooltip
          [headerText]="chart.tooltip ? chart.tooltip.headerText : ''"
          [isFeatureInaccessibleType]="disabled"
          [tooltipText]="chart.tooltip ? chart.tooltip.text : ''"
          [featureConst]="chart.featureConst"
          [featureName]="chart.toggleTitle"
          (openTooltipModal)="handleTooltipModalOpen($event)"
        ></app-feature-tooltip>
      }
    </app-slide-toggle>

    @if (chart.accessibleYears && chart.accessibleYears.length > 0) {
      <app-chart-year-selection
        [isChartVisible]="featureStatus!.isSelected && toggle && toggle!.value"
        [selectedYear]="$any(featureStatus)![chart.yearVariable!]"
        [accessibleYears]="chart.accessibleYears"
        [usedFor]="chart.yearVariable!"
        (selectedYearChange)="onSelectedYearChange($event)"
      ></app-chart-year-selection>
    }

    @if (
      toggle.value &&
      featureStatus!.isSelected &&
      $any(featureStatus)[chart.containsChartDataVariable]
    ) {
      <div class="chart">
        <app-plotly-chart
          [naturalId]="featureStatus!.naturalId"
          [selectedYear]="$any(featureStatus)![chart.yearVariable!]"
          [chart]="
            chart.plotlyChart ||
            chart.chartsByYears![$any(featureStatus)[$any(chart.yearVariable)]]
          "
          [chartStyle]="chart.chartStyle || defaultChartStyle"
          [chartName]="chart.chartName"
          [e2eName]="chart.e2eName"
          [featureConst]="chart.featureConst"
        ></app-plotly-chart>
      </div>
    }

    <app-chart-warning
      [selectedYear]="
        wasYearSelected ? $any(featureStatus)![chart.yearVariable!] : undefined
      "
      [selected]="featureStatus.isSelected"
      [containsInfo]="$any(featureStatus)[chart.containsChartDataVariable]"
      [isToggleActive]="toggle && toggle.value"
      [noAccessibleYears]="chart.accessibleYears?.length === 0"
      [chartName]="chart.chartName"
    ></app-chart-warning>
  </div>
}
